export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10182.a06227e7.jpg";